import { createApp, defineAsyncComponent } from 'vue';
import store from 'shared/store';
import {
	initFormKitSchema,
	formKitSchemaOptions,
} from 'shared/utils/initFormKitSchema';

async function mountCheckoutItem() {
	const checkoutItem = document.querySelector('[data-checkout-item]');

	if (!checkoutItem) {
		console.warn('[CheckoutItem] Container not found');
		return;
	}

	const options = await formKitSchemaOptions();
	const app = createApp({
		name: 'CheckoutItemApp',
	});
	app.component(
		'prescription-upload-block',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "prescription-upload-block" */ 'multisite/components/formElements/checkoutPrescriptionBlocks/checkoutPrescriptionUploadBlock.vue'
				),
		),
	);
	app.component(
		'checkout-modal-login',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "checkout-modal-login" */ 'multisite/components/checkout/checkoutModalLogin.vue'
				),
		),
	);
	app.component(
		'checkout-submitted-summary',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "checkout-submitted-summary" */ 'multisite/components/checkout/checkoutSubmittedSummary.vue'
				),
		),
	);
	app.component(
		'order-quote-confirm',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "order-quote-confirm" */ 'multisite/components/checkout/orderQuoteConfirm.vue'
				),
		),
	);
	app.component(
		'progress-bar',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "progress-bar" */ 'shared/components/progressBar/progressBar.vue'
				),
		),
	);
	app.component(
		'delivery-cart',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "delivery-cart" */ 'Features/GlobalCheckout/SharedComponents/deliveryCart.vue'
				),
		),
	);
	app.component(
		'hcp-checkout-summary',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "hcp-checkout-summary" */ 'multisite/components/checkout/HcpCheckoutSummary.vue'
				),
		),
	);
	await initFormKitSchema(app, options);
	app.use(store);
	app.mount(checkoutItem);
}

mountCheckoutItem().catch((error) => {
	console.error('Error mounting CheckoutItem:', error);
});
